module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.href) ? _c('a', {
    class: _vm.linkClasses,
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2) : _c('span', {
    class: _vm.linkClasses
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.showSeparator) ? _c('span', {
    class: _vm.separatorClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.separator)
    }
  }) : _c('span', {
    class: _vm.separatorClasses
  }, [_vm._t("separator")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d933976"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/breadcrumb/breadcrumb-item.vue
// module id = 654
// module chunks = 1